export const ASSIGNMENT_ITEM_STATUS = {
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED'
}

export const ASSIGNMENT_ITEM_STATUS_TEXT = {
    PENDING: 'Pendiente',
    ACCEPTED: 'Aceptado',
    REJECTED: 'Denegado'
}

export const ASSIGNMENT_ITEM_STATUS_VARIANT = {
    PENDING: 'warning',
    ACCEPTED: 'success',
    REJECTED: 'danger'
}
